import { useState } from 'react'
import { useAppContext } from '../Context';

//import tags
import { Container, Image, Row, Col, Tab, Tabs, Accordion } from 'react-bootstrap'
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faChevronDown, faSignOutAlt, faUser, faPlus } from '@fortawesome/free-solid-svg-icons';

// import components
import { propertyTypeOptions } from '../utils/PropertyOptions';

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

function Sidemenu({ setSideMenuModal, locale }) {

    const { isLoggedIn, logout } = useAppContext();

    //get locale
    const { t } = useTranslation();

    const [expandedMenu, setExpandedMenu] = useState(null);

    const toggleMenu = (menu) => {
        setExpandedMenu(expandedMenu === menu ? null : menu);
    };

    return (
        
        <div className="sidebarContainer">
            <div className="closeSidebarModal" onClick={() => setSideMenuModal(false)}>
                <FontAwesomeIcon icon={faTimes} />
            </div>

            <div className="menuInner">
                <div className="sideMenuHeader">
                    <h4>{t('menu')}</h4>
                </div>

                <div className="mainSideMenuBox">
                    {/* Property Navigation Menu */}
                    <nav className="shortNav">
                        <ul>
                            {/* For Sale */}
                            <li>
                                <Link 
                                    onClick={() => toggleMenu('sale')}
                                    to={`/${locale}/property`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {t('for_Sale')} <span><FontAwesomeIcon icon={faChevronDown} /></span>
                                </Link>
                                {expandedMenu === 'sale' && (
                                    <ul className="dropdown">
                                        <div className="dropdownBox">
                                            {propertyTypeOptions.map((propertyOptions) => (
                                                <li key={propertyOptions.value}>
                                                    <Link 
                                                        onClick={() => setSideMenuModal(false)} 
                                                        to={`/${locale}/property?page=1&transaction_type=sale&property_type=${propertyOptions.value}`}
                                                    >
                                                        {propertyOptions.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </div>
                                    </ul>
                                )}
                            </li>

                            {/* For Rent */}
                            <li>
                                <Link 
                                    onClick={() => toggleMenu('rent')}
                                    to={`/${locale}/property`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {t('for_rent')} <span><FontAwesomeIcon icon={faChevronDown} /></span>
                                </Link>
                                {expandedMenu === 'rent' && (
                                    <ul className="dropdown">
                                        <div className="dropdownBox">
                                            {propertyTypeOptions.map((propertyOptions) => (
                                                propertyOptions.value !== 'farm' && propertyOptions.value !== 'business' && propertyOptions.value !== 'land' ?
                                                    <li key={propertyOptions.value}>
                                                        <Link 
                                                            onClick={() => setSideMenuModal(false)} 
                                                            to={`/${locale}/property?page=1&transaction_type=rent&property_type=${propertyOptions.value}`}
                                                        >
                                                            {propertyOptions.label}
                                                        </Link>
                                                    </li>
                                                    : ''
                                            ))}
                                            <li>
                                                <Link 
                                                    onClick={() => setSideMenuModal(false)} 
                                                    to={`/${locale}/property?page=1&transaction_type=lease&property_type=land`}
                                                >
                                                    {t('lease_land')}
                                                </Link>
                                            </li>
                                        </div>
                                    </ul>
                                )}
                            </li>

                            {/* For Pledge */}
                            <li>
                                <Link 
                                    onClick={() => toggleMenu('pledge')}
                                    to={`/${locale}/property`}
                                    style={{ cursor: 'pointer' }}
                                >
                                    {t('for_pledge')} <span><FontAwesomeIcon icon={faChevronDown} /></span>
                                </Link>
                                {expandedMenu === 'pledge' && (
                                    <ul className="dropdown">
                                        <div className="dropdownBox">
                                            {propertyTypeOptions.map((propertyOptions) => (
                                                <li key={propertyOptions.value}>
                                                    <Link 
                                                        onClick={() => setSideMenuModal(false)} 
                                                        to={`/${locale}/property?page=1&transaction_type=pawn&property_type=${propertyOptions.value}`}
                                                    >
                                                        {propertyOptions.label}
                                                    </Link>
                                                </li>
                                            ))}
                                        </div>
                                    </ul>
                                )}
                            </li>
                        </ul>
                    </nav>

                    <Accordion>
                        
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>{t('real_estate')}</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/photovideo`}>{t('photovideo')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/capture`}>{t('3d_capture')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/rate`}>{t('measure_rate')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/exclusive`}>{t('exclusive_service')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/management`}>{t('management')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/ads`}>{t('soc_ads')}</Link></li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>{t('architecture_design')}</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/architect`}>{t('architect')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/urban`}>{t('urban')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/costservice`}>{t('sost_service')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/interiordesign`}>{t('interior_exterior_design')}</Link></li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>{t('legal_service')}</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/consulting`}>{t('legal_advices')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/check`}>{t('check_before_buy')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/propertyregistration`}>{t('estate_registration')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/businessregistration`}>{t('business_register')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/purchaseagreement`}>{t('ready_contract')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/leaseagreement`}>{t('loan_contract')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/Legalsupport`}>{t('full_legal_support')}</Link></li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>{t('company')}</Accordion.Header>
                            <Accordion.Body>
                                <ul>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/about`}>{t('about_us')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/newses`}>{t('news')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/cities`}>{t('popular_cities')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/videos`}>{t('vedeo_news')}</Link></li>
                                    <li><Link onClick={() => setSideMenuModal(false)} to={`/${locale}/contact`}>{t('contact')}</Link></li>
                                </ul>
                            </Accordion.Body>
                        </Accordion.Item>
                        
                        <div className='OtherMenu'>
                            <Link onClick={() => setSideMenuModal(false)} to={`/${locale}/clients`}>{t('client')}</Link>

                            <Link className='colGrey' onClick={() => setSideMenuModal(false)} to="">{t('measurement')}</Link>
                            <Link className='colGrey' onClick={() => setSideMenuModal(false)} to="">{t('insurance')}</Link>
                            <Link className='colGrey' onClick={() => setSideMenuModal(false)} to="">{t('mortgage')}</Link>
                        </div>

                    </Accordion>

                </div>

                {/* Auth section at the bottom of the side menu */}
                <div className="sideMenuAuthSection">
                    <Link
                        className="sideMenuAddPropertyBtn"
                        to={`/${locale}/property/add`}
                        onClick={() => setSideMenuModal(false)}
                    >
                        <span className="sideMenuAuthIcon"><FontAwesomeIcon icon={faPlus} /></span>
                        {t('add_property')}
                    </Link>

                    {isLoggedIn && typeof isLoggedIn === 'object' ? (
                        <>
                            <Link
                                className="sideMenuProfileBtn"
                                to={`/${locale}/profile/main`}
                                onClick={() => setSideMenuModal(false)}
                            >
                                <span className="sideMenuAuthIcon"><FontAwesomeIcon icon={faUser} /></span>
                                {t('hello')}: {isLoggedIn?.fname}
                            </Link>
                            <button
                                className="sideMenuLogoutBtn"
                                onClick={() => { logout(); setSideMenuModal(false); }}
                            >
                                <span className="sideMenuAuthIcon"><FontAwesomeIcon icon={faSignOutAlt} /></span>
                                {t('log_out')}
                            </button>
                        </>
                    ) : (
                        <button
                            className="sideMenuLoginBtn"
                            onClick={() => setSideMenuModal(false)}
                        >
                            <span className="sideMenuAuthIcon"><FontAwesomeIcon icon={faUser} /></span>
                            {t('login_register')}
                        </button>
                    )}
                </div>

            </div>

        </div>
    )

}

export default Sidemenu;

